import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import "./bannerMentoria.scss";

const BannerMentoria = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        tituloBoton,
        redireccionBoton,
        imagenPrincipal,
        descripcion
    } = props;
    const url = new URL(window.location.href);

    const HOME_SERVICIOS_EMPRESARIALES = "5OIUYlRKuBSmNA7gY0j9Rk";

    const scrollToMentoringSection = () => {
        const element = document.querySelector('.m-carousel-mentors');
        if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset - 170;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className="a-mentoring-banner">
                <div className="o-image">
                    <img className="o-image__container" src={imagenPrincipal.file.url}/>
                </div>
                <div className="o-text">
                    <h2 className="o-text__title">{tituloGeneral}</h2>
                    <p className="o-text__description">{descripcion?.json.content[0].content[0].value}</p>
                </div>
                <div className="o-button">
                    {props.contentful_id === HOME_SERVICIOS_EMPRESARIALES ? (
                            <Button
                                onClickAction={scrollToMentoringSection}
                                type="button"
                                text={tituloBoton}
                                classname={`a-button__magenta`}
                                isDisabled={false}
                            />
                        ) : (
                            <Button
                                type="link"
                                text={tituloBoton}
                                classname="a-button__magenta"
                                href={redireccionBoton}
                                isDisabled={false}
                            />
                        )
                    }
                </div>
            </div>
        </>
    )
};
export default BannerMentoria;
